define(function (require) {
    "use strict";

    var LE = require("app");

    var ApiResources = require("assets/data/apiResources.json");

    var RevisionedCollection = require('collections/RevisionedCollection');
    var WidgetModel = require("personalization-web-agent-models/WidgetModel");
    var OrderedCollection = require("collections/OrderedCollection");

    var WidgetCollection = {};
    LE.module("LEPersonalization", function (LEPersonalization, LE, Backbone, Marionette, $, _) {
        WidgetCollection = OrderedCollection.extend({
            resource: ApiResources.AccountConfig.Personalization.AgentWidgets,
            model : WidgetModel,

            comparator : function (widgetModel) {
                return widgetModel.get(WidgetModel.KEYS.ORDER);
            },
            parse: function (response, options) {
                response = _.sortBy(response, "order");
                return RevisionedCollection.prototype.parse.call(this, response, options);
            },
            getCustomWidgetsSum: function() {
                var customWidgets = this.filter(function (model) {
                    return model.getType() === model.TYPES.IFRAME;
                });

                return customWidgets.length;
            },
            /**
             * Create bulk of core widgets
             * @param newWidgets - array of objects
             */
            createCoreWidgets: function (newWidgets) {
                var widgetsData = [];
                if (!_.isEmpty(newWidgets)) {
                    _.each(newWidgets, (function(widget) {
                        widget.mode = this.model.MODES.PUBLISHED;
                        widget.url = "";
                        widget = new WidgetModel(widget);
                        widgetsData.push(widget.toJSON());
                    }).bind(this));

                    if (widgetsData.length > 0) {
                        var saveOptions = {
                            "data": widgetsData,
                            "contentType": "application/json",
                            "type": "POST",
                            "headers": {}
                        };

                        this.fetch(saveOptions);
                    }
                }
            }
        });
    });
    return WidgetCollection;
});
